import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import * as Sentry from '@sentry/react';
import { registerSW } from 'virtual:pwa-register';

registerSW({ immediate: true });

Sentry.init({
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: 'frontend',

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.browserSessionIntegration(),
    Sentry.browserProfilingIntegration(),
  ],
  replaysSessionSampleRate: 0.1,
  sendDefaultPii: true,
  tracesSampleRate: 0.1,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
